<template>
  <div>
    <instSystemScreenDescription>
      <template v-slot:icon>
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.9 17.967c.6.533 1.967 1.3 3.667 1.3.466 0 1.033-.1 1.566-.234 2.367-.633 3.6-2.5 3.934-3.533a1.68 1.68 0 00-3.167-1.1 2.567 2.567 0 01-1.667 1.433c-1.233.3-2.133-.4-2.133-.4a1.683 1.683 0 00-2.367.167c-.6.7-.533 1.767.167 2.367zm18.733 1.3c-.466 0-.966-.067-1.5-.2-2.366-.634-3.6-2.534-3.933-3.534-.3-.866.167-1.833 1.033-2.1.867-.3 1.834.167 2.1 1.034 0 0 .434 1.066 1.634 1.4 1.233.333 2.1-.367 2.133-.4.7-.567 1.733-.5 2.333.2.6.7.534 1.733-.166 2.333-.634.567-1.967 1.267-3.634 1.267zm1.51 10.523a1.668 1.668 0 00.647-2.267c-2.017-3.63-5.623-5.856-9.79-5.856-4.167 0-7.773 2.226-9.79 5.856a1.667 1.667 0 002.913 1.62C14.563 26.547 17.07 25 20 25c2.927 0 5.433 1.547 6.877 4.143a1.665 1.665 0 002.266.647zM40 20a20 20 0 11-40 0 20 20 0 0140 0zm-3.333 0a16.667 16.667 0 10-33.334 0 16.667 16.667 0 0033.334 0z" fill="#3DAE2B"/></svg>
      </template>
      <template v-slot:title>
        <h3>К сожалению, мы не можем выдать вам заём</h3>
      </template>
      <template v-slot:description>
        <p>Новую заявку вы сможете подать после {{nextDate}}</p>
      </template>
    </instSystemScreenDescription>
  </div>
</template>

<script>
export default {
  name: "instRejectTime",
  components:{
    instSystemScreenDescription: ()=> import('@/components/inst/instSystemScreenDescription.vue')
  },
  computed:{
    nextDate(){
      let date = new Date();
      date.setDate(date.getDate() + 30);
      return date.toISOString().split('T')[0].split('-').reverse().join('.')
    }
  },
  mounted() {
    if (window.canRedirect === 1) {
      this.$palantir.trackAction(128,window.linkToMarket);
      document.location.href = window.linkToMarket;
    }
  }
}
</script>

<style scoped>

</style>